import axios from "../../../utils/fvAxios";
import BaseURL from "../../../utils/base-uri.json";
import React, { useRef, useState, useEffect } from "react";
import CommunicationListItem from "./CommunicaitonListItem";
import LoadingSpinner from "../../../toolkit/LoadingSpinner";
import ErrorAlert from "../../../toolkit/ErrorAlert";
import { Box } from "@mui/material";
import Delayed from "../../../utils/Delayed";
import ListSkeleton from "../Communication/ListSkeleton";

let error = false;
const MESSAGE_LIMIT = 20; // number of messages to fetch at a time
const SCROLL_THRESHOLD = 100; // number of pixels from the bottom to trigger fetching more messages
let page = 1;
let isLoading = false;
let hasMore = true;
let totalPages = 1;
const CommunicationList = ({ searchStr, handleItemClick }) => {
  const [communications, setCommunications] = useState([]);
  const listContainerRef = useRef(null);
  const [loader, setloader] = useState(true);

  // fetch messages from API
  const fetchMessages = async () => {
    
    if (isLoading || !hasMore) return;
    isLoading = true;
    error = false;
    try {
      const response = await axios.get(
        BaseURL.baseUrl +
          BaseURL.widget.GetCommunicationList +
          "?searchValue=" +
          encodeURIComponent(searchStr) +
          "&pageSize=" +
          MESSAGE_LIMIT +
          "&pageNumber=" +
          page
      );

      if (response.status == 200) {
        if (response.data.data) {
          setCommunications((prevCommunications) => {
            // remove any duplicates from the new communications before adding them to the existing array
            setloader(false)
            const newCommunications = response.data.data.filter(
              (communication) =>
                !prevCommunications.some(
                  (prevComm) =>
                    prevComm.prequalificationId ===
                    communication.prequalificationId
                )
            );
            totalPages = Math.ceil(
              response.data?.data[0]?.totalMessageCount / MESSAGE_LIMIT
            );
            return [...prevCommunications, ...newCommunications];
          });
          if (response.data?.data?.length === 0) hasMore = false;
          setloader(false)
          isLoading = false;
        }
      }
    } catch (e) {
      console.error(e);
      error = true;
      isLoading = false;
    }
  }

  // handle scroll event and trigger fetching more messages
  const handleScroll = () => {
    const container = listContainerRef.current;
    const scrolledToBottom =
      container.scrollTop + container.clientHeight >=
      container.scrollHeight - SCROLL_THRESHOLD;
    if (scrolledToBottom) {
      if (!isLoading) {
        if (totalPages >= page) {
          page = page + 1;
          fetchMessages();
        }
      }
    }
  };

  // attach scroll event listener when component mounts
  useEffect(() => {
    totalPages = 1;
    hasMore = true;
    page = 1;
    isLoading = false;
    fetchMessages();
    const container = listContainerRef.current;
    container.addEventListener("scroll", handleScroll);
    return () => {
      isLoading = true;
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Box
      ref={listContainerRef}
      px={3}
      style={{ height: "800px", overflowY: "scroll" }}
      className="list overflow-auto"
    >

      {error ? (
        <ErrorAlert message={"Error fetching information"} />
      ) : (
        isLoading||loader && <LoadingSpinner />
      )}
      {!isLoading||!loader && communications.length === 0 && (
        <Delayed waitBeforeShow={2000}>
          <ErrorAlert severity="warning" hidden={isLoading} message={"No results found!"} />
        </Delayed>
      )}

      {(isLoading||loader && communications.length === 0) ? (
        <ListSkeleton />
      ) : (
        communications.map((i, idx) => (
          <div className="list-item px-0" key={idx}>
            <CommunicationListItem {...i} handleItemClick={handleItemClick} />
          </div>
        ))
      )}
    </Box>
  );
};
export default CommunicationList;
